var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"okAction":_vm.ok,"title":_vm.title,"id":_vm.id,"actionButtons":true,"closeButton":false}},[_vm._v(_vm._s(_vm.$t(_vm.text || 'Do you really want to delete the record ?')))])}
var staticRenderFns = []

export { render, staticRenderFns }